// file: thirdparty.js


const loadKlaviyo = () => {
  let a = document.createElement("script");
  a.setAttribute(
    "src",
    "https://a.klaviyo.com/media/js/onsite/onsite.js"
  );

  a.onload = () => {
    var klaviyo = window.klaviyo || [];
    klaviyo.init({
      account: "XSJuSF",
      platform: "shopify"
    });
    klaviyo.enable("backinstock", {
      trigger: {
        product_page_text: "Notify Me When Available",
        product_page_class: "btn",
        product_page_text_align: "center",
        product_page_margin: "0px",
        replace_anchor: false
      },
      modal: {
        headline: "{product_name}",
        body_content: "Register to receive a notification when this item comes back in stock.",
        email_field_label: "Email",
        button_label: "Notify me when available",
        subscription_success_label: "You're in! We'll let you know when it's back.",
        footer_content: '',
        drop_background_color: "#000",
        background_color: "#fff",
        text_color: "#222",
        button_text_color: "#fff",
        button_background_color: "#51a366",
        close_button_color: "#ccc",
        error_background_color: "#fcd6d7",
        error_text_color: "#C72E2F",
        success_background_color: "#d3efcd",
        success_text_color: "#1B9500"
      }
    });
  };
  document.head.insertAdjacentElement("beforeend", a);
}

const loadHotJar = () => {
  (function (h, o, t, j, a, r) {
    h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
    h._hjSettings = { hjid: 2693544, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script'); r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

const loadScripts = () => {
  loadKlaviyo();
  loadHotJar();

};
document.addEventListener('UserInteracted', loadScripts, false);

// clarity snippet
(function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "9m41qgyud6");
